import { AppModule } from 'utils/constants';
import {
  GetDeviceProductionPlanDetailResponse,
  ProductionPlanRevisionInterface
} from 'features/dispatcher/dispatcherTypes';
import {
  DataGridDensity,
  DataGridVisibility
} from 'components/dataGrid/dataGridModels';

// ==============================|| H+X PLANNING UTILS ||============================== //

export type ProductionPlanRevisionMap = Map<
  string,
  ProductionPlanRevisionInterface
>;

export interface HxPlanningFilter {
  filterValue: string[];
  setFilterValue: (value: string[]) => void;
}

export interface HxPlanningTablesProps
  extends Omit<DataGridDensity, 'setDensity'>,
    Omit<DataGridVisibility, 'setColumnsVisibilityModel'>,
    Omit<HxPlanningFilter, 'setFilterValue'> {}

export const I18N_HX_PLANNING_ROOT = `module.${AppModule.DISPATCHER}.hxDashboard.hxPlanning`;
export const I18N_HX_PLANNING_HEADER_ROOT = `${I18N_HX_PLANNING_ROOT}.header`;

export const getRevisionsOfProductionPlansMap = (
  productionPlans: GetDeviceProductionPlanDetailResponse[]
): ProductionPlanRevisionMap => {
  return productionPlans.reduce((map: ProductionPlanRevisionMap, plan) => {
    const currentRevision = plan.revisions.find(
      (revision) => !revision.closingTime
    );
    if (currentRevision) map.set(plan.deviceId.toString(), currentRevision);
    return map;
  }, new Map());
};
